module.exports = __webpack_public_path__ + "static/media/expand.5881b281.svg";